module.exports = __webpack_public_path__ + "img/texas_brown_ba_list.ecb88a9c.jpg";